/**
 * Field options configuration for document header
 */

import {getCompartmentOptions, getDistributionOptions} from '../../helpers/classificationOptions';

export const ORIGINATOR_OPTIONS = [
    {value: '', label: 'Select originator'},
    {value: 'J2', label: 'J2'},
    {value: 'J3', label: 'J3'},
    {value: 'J5', label: 'J5'},
    {value: 'OSINT Office', label: 'OSINT Office'},
    {value: 'Intel Fusion Cell', label: 'Intel Fusion Cell'},
    {value: 'Operations', label: 'Operations'}
];

// Use distribution options from classificationOptions.js
export const DISTRIBUTION_OPTIONS = [
    {value: '', label: 'Select distribution'},
    ...getDistributionOptions()
];

// Use compartment options from classificationOptions.js
export const COMPARTMENT_OPTIONS = [
    {value: '', label: 'Select compartment'},
    ...getCompartmentOptions()
];

export const CONFIDENCE_OPTIONS = [
    {value: '', label: 'Select confidence'},
    {value: 'low', label: 'Low'},
    {value: 'moderate', label: 'Moderate'},
    {value: 'high', label: 'High'}
];

export const IFC_OPTIONS = [
    {value: '', label: 'Select IFC'},
    {value: 'IFC0000', label: 'IFC0000 - Non•Intelligence Subjects'},
    {value: 'IFC1000', label: 'IFC1000 - Ballistic Missile Forces'},
    {value: 'IFC1010', label: 'IFC1010 - Strategic-Level'},
    {value: 'IFC1011', label: 'IFC1011 - Strategic-Level Strategy, Doctrine, Plans, and Threat'},
    {value: 'IFC1012', label: 'IFC1012 - Strategic-Level Force Estimates and Trends'},
    {value: 'IFC1013', label: 'IFC1013 - Strategic-Level Organization'},
    {value: 'IFC1014', label: 'IFC1014 - Strategic-Level Leadership/Participation in National Affairs'},
    {value: 'IFC1015', label: 'IFC1015 - Strategic-Level Personnel Policies and Resources'},
    {value: 'IFC1016', label: 'IFC1016 - Strategic-Level Training and Exercises'},
    {value: 'IFC1030', label: 'IFC1030 - Ballistic Missile Forces Combat Systems RDT&E Characteristics'},
    {value: 'IFC1031', label: 'IFC1031 - Intercontinental Ballistic Missile'},
    {value: 'IFC1032', label: 'IFC1032 - Submarine-Launched Ballistic Missile'},
    {value: 'IFC1040', label: 'IFC1040 - Combat Support Force Capabilities, Doctrine, and Structure'},
    {value: 'IFC1050', label: 'IFC1050 - Combat Support Systems RDT&E Characteristics'},
    {value: 'IFC1060', label: 'IFC1060 - Unit-Level C4I Systems and Logistics'},
    {value: 'IFC1100', label: 'IFC1100 - Ground Forces'},
    {value: 'IFC1115', label: 'IFC1115 - Strategic-Level C4I'},
    {value: 'IFC1140', label: 'IFC1140 - Ground Forces Combat Systems Characteristics and Performance'},
    {value: 'IFC1150', label: 'IFC1150 - Tactical-Level Combat Support and Combat Service Support'},
    {value: 'IFC1160', label: 'IFC1160 - Tactical-Level Combat Support and Combat Service Support Systems'},
    {value: 'IFC1200', label: 'IFC1200 - Naval Forces'},
    {value: 'IFC1210', label: 'IFC1210 - Strategic-Level Force Issues'},
    {value: 'IFC1220', label: 'IFC1220 - Naval Tactics'},
    {value: 'IFC1236', label: 'IFC1236 - At-Sea Logistics/Maintenance/Repair'},
    {value: 'IFC1250', label: 'IFC1250 - Platform Characteristics and Performance'},
    {value: 'IFC1260', label: 'IFC1260 - Naval Sensors/Electronics'},
    {value: 'IFC1300', label: 'IFC1300 - Air Forces'},
    {value: 'IFC1310', label: 'IFC1310 - Strategic-Level Force Issues'},
    {value: 'IFC1330', label: 'IFC1330 - Unit-Level Force Capabilities, Doctrine, and Structure'},
    {value: 'IFC1400', label: 'IFC1400 - Space Forces'},
    {value: 'IFC1411', label: 'IFC1411 - Strategic-Level Strategy, Doctrine, Plans, and Threat'},
    {value: 'IFC1430', label: 'IFC1430 - Space Forces Structure, Capabilities, and Employment'},
    {value: 'IFC1500', label: 'IFC1500 - National Issues'},
    {value: 'IFC1510', label: 'IFC1510 - National Security Policies, Programs, Objectives, and Decisionmaking'},
    {value: 'IFC1520', label: 'IFC1520 - Support to Command and Control Warfare'},
    {value: 'IFC1521', label: 'IFC1521 - National Command, Control, Communications, Computers, and Intelligence (C4I)'},
    {value: 'IFC1530', label: 'IFC1530 - Sociological Issues and Factors'},
    {value: 'IFC1540', label: 'IFC1540 - Multiservice/Multinational Forces'},
    {value: 'IFC1560', label: 'IFC1560 - Proliferation of Technology and Weapons Transfer'},
    {value: 'IFC1600', label: 'IFC1600 - Nuclear, Biological, and Chemical Warfare'},
    {value: 'IFC1610', label: 'IFC1610 - Nuclear Programs'},
    {value: 'IFC1650', label: 'IFC1650 - Chemical and Biological Warfare Programs'},
    {value: 'IFC1700', label: 'IFC1700 - Electronics'},
    {value: 'IFC1710', label: 'IFC1710 - Microelectronics'},
    {value: 'IFC1740', label: 'IFC1740 - Sensor Technologies'},
    {value: 'IFC1810', label: 'IFC1810 - Medical Sciences'},
    {value: 'IFC1820', label: 'IFC1820 - Mathematical and Physical Sciences / Control Theory'},
    {value: 'IFC1850', label: 'IFC1850 - Energy Conversion and Power Technology'},
    {value: 'IFC1900', label: 'IFC1900 - Resources and Economics'},
    {value: 'IFC1910', label: 'IFC1910 - Economics'},
    {value: 'IFC1925', label: 'IFC1925 - Military Materiel Identification'},
    {value: 'IFC2000', label: 'IFC2000 - Transportation'},
    {value: 'IFC2100', label: 'IFC2100 - Physical Environment'},
    {value: 'IFC2200', label: 'IFC2200 - Illicit Activities and Law Enforcement'},
    {value: 'IFC2300', label: 'IFC2300 - Intelligence and Security'},
    {value: 'IFC2350', label: 'IFC2350 - Positive Intelligence Operations'}
];

export const PRODUCTION_CENTER_OPTIONS = [
    {value: '', label: 'Select production center'},
    {value: 'D1', label: 'DIA — Defense Intelligence Agency'},
    {value: 'EX', label: 'JAC/JIOCEUR AC — EUCOM JIOCEUR Analytic Center'},
    {value: 'NM', label: 'MCIA — Marine Corps Intelligence'},
    {value: 'AF', label: 'NASIC — National Air and Space Intelligence Center'},
    {value: 'VT', label: 'NGA — National Geospatial-Intelligence Agency'},
    {value: 'RB', label: 'NGIC — National Ground Intelligence Center'},
    {value: 'NS', label: 'NSA — National Security Agency'},
    {value: 'NX', label: 'ONI — Office of Naval Intelligence'},
    {value: 'A1', label: 'USAFRICOM JIOC — USAFRICOM Joint Intelligence Operations Center'},
    {value: 'RT', label: 'USCENTCOM JIOC — USCENTCOM Joint Intelligence Operations Center'},
    {value: 'C1', label: 'USCYBERCOM ICC/JOC — USCYBERCOM Integrated Cyber Center / Joint Operations Center'},
    {value: 'EC', label: 'USINDOPACOM JIOC — USINDOPACOM Joint Intelligence Operations Center'},
    {value: 'N1', label: 'USNORTHCOM JIOC — USNORTHCOM Joint Intelligence Operations Center'},
    {value: 'HA', label: 'USSOUTHCOM JIOC — USSOUTHCOM Joint Intelligence Operations Center'},
    {value: 'S1', label: 'USSPACECOM JIOC — USSPACECOM Joint Intelligence Operations Center'},
    {value: 'YG', label: 'USTRANSCOM J2 (JICTRANS) — USTRANSCOM Intelligence Directorate'}
];

export const DEFAULT_HEADER_DATA = {
    dtg: '',
    originator: {value: '', label: 'Select originator'},
    classification: {value: 'TS', label: 'TS - Top Secret'},
    distribution: [],
    compartment: [],
    confidence: {value: '', label: 'Select confidence'},
    ifc: {value: '', label: 'Select IFC'},
    productionCenter: {value: '', label: 'Select production center'},
    authors: []
};


